import { useContext, useState } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import InfoIcon from '../../../assets/icons/alert.svg';
import LineItemsPreview from '../Components/LineItemsPreview';
import { useEffect } from 'react';
import { Resizable } from 're-resizable';
import { useTranslation } from 'react-i18next';
import { produce, setAutoFreeze } from 'immer';
import { set } from 'lodash';

const OuterContainer = styled.div`
  padding: 2px;

  &.active {
    border: 1px solid rgba(0, 115, 234, 0.4) !important;
    border-radius: 1px !important;
  }

  &.hover-active:hover {
    border: 1px solid rgba(0, 115, 234, 0.4) !important;
    border-radius: 1px !important;
  }
`;

const EmptyContainer = styled.div`
  width: ${({ width }) => width + 'px'};
  background-color: white;

  .alert {
    height: 40px;
    width: 100%;
    padding: 10px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-radius: 4px;
    background: var(--light-allgrey-background-color, #f5f6f8);
    color: var(--light-primary-text-color, #323338);
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const Edit = ({ item, setIsResizing, isResizable }) => {
  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    subItems,
    pdfDefaultHeight,
    draggableFieldsData,
  } = useContext(FileContext);
  setAutoFreeze(false);

  const { t } = useTranslation();

  const defaultHeight = '100%';
  const defaultWidth = 564;

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    // Get the actual dimensions from the resize event
    const newWidth = _ref.clientWidth;
    const newHeight = _ref.clientHeight;

    item.width = newWidth;
    item.height = newHeight;

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: newHeight,
      width: newWidth,
    };
    updateFormFields([...addedFormFields]);
  };

  const handleResize = (e, _dir, _ref, d) => {
    // setFontSize(calculateFontSize(d.height, item.fontSize));
  };

  useEffect(() => {
    if (!item?.width) item.width = defaultWidth;
    if (!item?.height) item.height = defaultHeight;
    // if (!item?.fontSize) item.fontSize = defaultFontSize;
  }, []);

  const onColumnSizingChange = (columnSizing) => {
    setIsResizing(true);
  };

  const handleColumnResizeStart = () => {
    setIsResizing(true);
  };

  const handleColumnResizeEnd = () => {
    setIsResizing(false);
  };

  const setColumnPercentages = (percentages) => {
    const updatedFormFields = produce(addedFormFields, (draft) => {
      const index = draft.findIndex((field) => field.id === item.id);
      if (index !== -1) {
        const requiredColumns = item.subItemSettings.columns.map(
          (column) => column.id,
        );
        if (item.subItemSettings.itemNameColumn.checked) {
          requiredColumns.unshift('item-name');
        }
        let hasAllRequiredColumns = true;
        for (const column of requiredColumns) {
          if (!percentages[column]) {
            hasAllRequiredColumns = false;
            break;
          }
        }
        if (hasAllRequiredColumns) {
          set(draft, `[${index}].subItemSettings.columnWidth`, percentages);
        }
      }
    });
    updateFormFields(updatedFormFields);
  };

  return (
    <OuterContainer className={item.isActive ? 'active' : 'hover-active'}>
      {subItems ? (
        <>
          {item.subItemSettings && subItems?.columns?.length ? (
            <Resizable
              size={{
                height: item?.height || defaultHeight,
                width: item?.width || defaultWidth,
              }}
              lockAspectRatio={false}
              enable={{
                top: false,
                right: item?.isActive,
                bottom: item?.isActive,
                left: false,
                topRight: false,
                bottomRight: item?.isActive,
                bottomLeft: false,
                topLeft: false,
              }}
              minWidth="300px"
              minHeight="fit-content"
              className={'resizeable'}
              onResizeStart={handleResizeStart}
              onResizeStop={handleResizeEnd(item)}
              onResize={handleResize}
            >
              <LineItemsPreview
                spaceInFirstPage={pdfDefaultHeight - item.placeholder.y}
                pageNumber={item.formField.pageNumber}
                lineItemData={item?.subItemSettings}
                lineItemId={item?.id}
                width={item?.width || defaultWidth}
                mondayColumnsData={subItems?.columns}
                isPreview
                t={t}
                isResizable={isResizable}
                onColumnSizingChange={onColumnSizingChange}
                onColumnResizeStart={handleColumnResizeStart}
                onColumnResizeEnd={handleColumnResizeEnd}
                setColumnPercentages={setColumnPercentages}
              />
            </Resizable>
          ) : (
            <EmptyContainer width={defaultWidth}>
              <div className="alert">
                <img src={InfoIcon} alt="" />
                {t(
                  'Sub-items are pulled from your board sub-items. Add sub-items to your board to reflect them here.',
                )}
              </div>
            </EmptyContainer>
          )}
        </>
      ) : null}
    </OuterContainer>
  );
};

export default Edit;
